import request from '@/axios'

export function UploadImage (payload) {
  return request({
    url:'/file/image',
    method:'POST',
    data:payload
  })
}
export function ClientUploadImage (payload, customer_id) {
  return request({
    url:`ClientUser/file/upload/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function GetLanguageList () {
  return request({
    url:'/ClientUser/platformLanguages/list',
    method:'GET'
  })
}
export function GetCountryList () {
  return request({
    url:'/ClientUser/platformCustomerCountries/list',
    method:'GET'
  })
}

export function fetchTimeZoneList () {
  return request({
    url:'/ClientUser/get_timezone',
    method:'GET'
  })
}

export function customer_info () {
  return request({
    url:'/ClientUser/customer_info',
    method:'GET'
  })
}

